import _ from 'lodash';
import { TradingBlockLegacyUrlsLookup, TradingBlockUrlsLookup } from '@tradingblock/types';
import { GetSiteGrp, GetSiteName } from './SiteUtilities';
export const GetTradingBlockSiteName = (accountNumber, siteGroup, origin) => {
    return GetSiteName(siteGroup || 'tb', origin, accountNumber);
};
// GetTradingBlockDomain returns domain in start case (i.e. "TradingBlock.com")
export const GetTradingBlockDomain = (accountNumber, siteGroup, origin) => {
    const siteName = GetTradingBlockSiteName(accountNumber, siteGroup, origin);
    return `${siteName}.com`;
};
export const GetTradingBlockFullUrl = (urlKey, domain, config, origin) => {
    const defaultRedirect = _.get(config, 'defaultRedirect');
    const isDev = (defaultRedirect && defaultRedirect.includes('devdashboard')) ||
        (defaultRedirect && defaultRedirect.includes('devapplication'));
    const isBeta = defaultRedirect && defaultRedirect.includes('betadashboard');
    const isVirtual = _.get(config, 'isVirtual');
    if (urlKey === 'LegacySiteHomeUrl') {
        return domain === 'MoneyBlock.com' ? 'https://legacy.moneyblock.com' : 'https://legacy.tradingblock.com';
    }
    const fulldomain = domain.toLowerCase();
    const url = TradingBlockUrlsLookup[urlKey];
    if (urlKey === 'OpenNewAccountUrl') {
        const appDomain = isDev
            ? 'devapplication'
            : isBeta
                ? 'betaapplication'
                : isDev && isVirtual
                    ? 'vtdevapplication'
                    : !isDev && isVirtual
                        ? 'vtapplication'
                        : 'application';
        return `https://${appDomain}.${fulldomain}${url}`;
    }
    const isLegacyURL = urlKey in TradingBlockLegacyUrlsLookup;
    const host = isLegacyURL ? 'legacy' : 'www';
    return `https://${host}.${fulldomain}${url}`;
};
export const GetLogoutUrl = (accountNumber, siteGroup) => {
    return `/logout?grp=${GetSiteGrp(siteGroup, accountNumber)}`;
};
export const setPageTitle = (title, siteName) => {
    document.title = `${siteName || ''}${title && siteName ? ' - ' : ''}${title}`;
};
//# sourceMappingURL=site.js.map